import { createStore } from "./createStore";

const base = (set) => ({
  wsConnected: false,
  // Keep legacy properties for backward compatibility during transition
  inputWsConnected: false,
  outputWsConnected: false,

  setWsConnected: (val) =>
    set({ wsConnected: val, inputWsConnected: val, outputWsConnected: val }),
  // Legacy setters - update all connection states for consistency
  setInputWsConnected: (val) =>
    set({ inputWsConnected: val, wsConnected: val, outputWsConnected: val }),
  setOutputWsConnected: (val) =>
    set({ outputWsConnected: val, wsConnected: val, inputWsConnected: val }),
});

export const useWebsocketStore = createStore("WebsocketStore", base);
